import FAQ2 from './FAQ2'
export default FAQ2
